import type { IControlSelectCampaignItem } from './SelectCampaignItem';
import type { CompoundSelectSettingType } from '../../type';
import type { CampaignOptionType } from '../types';
import type { Campaign } from '~/types/graphql';

import { WrapperActivator } from '../../SelectCompound/components/WrapperActivator';
import { SelectCampaignPopover } from './SelectCampaignPopover';
import { getSelectLabel } from '../../SelectCompound/utils';
import { useSelectCampaignItemContent } from '../hooks';
import { useState, useCallback } from 'react';

export type CampaignConfigType = CompoundSelectSettingType & {
  campaignOptions?: CampaignOptionType[];
  isOperator?: boolean;
};

export interface ControlSelectCampaignContentProps extends IControlSelectCampaignItem {
  campaigns?: Campaign[];
  campaignGroupId?: string;
}
export const SelectCampaignContent: React.FC<ControlSelectCampaignContentProps> = ({
  configs,
  disabled,
  campaigns,
  campaignGroupId,
}) => {
  const { formatConfigs } = useSelectCampaignItemContent({ configs, campaigns });

  const [activePopovers, setActivePopovers] = useState<boolean[]>(() =>
    new Array(formatConfigs?.length ?? 0).fill(false),
  );

  const togglePopover = useCallback((index: number) => {
    setActivePopovers((prev) => {
      const next = [...prev];
      next[index] = !next[index];
      return next;
    });
  }, []);

  const getPopoverSelect = (config: CampaignConfigType, index: number) => {
    if (config.hide) return null;

    const { defaultValue, campaignOptions } = config;

    const options = config.isOperator ? config.options : campaignOptions;

    return (
      <div key={index} style={{ minWidth: index === 0 ? 'fit-content' : '0' }}>
        <SelectCampaignPopover
          key={index}
          activator={
            <WrapperActivator
              label={getSelectLabel(defaultValue, options)}
              onClick={() => togglePopover(index)}
              disabled={disabled}
              isChildren={index === 0}
            />
          }
          campaignGroupId={campaignGroupId}
          popoverActive={activePopovers[index]}
          togglePopoverActive={() => togglePopover(index)}
          {...config}
          width={config.isOperator ? '170px' : '400px'}
        />
      </div>
    );
  };

  if (!formatConfigs?.length) return null;

  return formatConfigs.map((config, index) => getPopoverSelect(config, index));
};
